<label [ngClass]="{'vertical':vertical,'disabled':disabled}">
  <input type="checkbox" [disabled]="disabled" [(ngModel)]="active" (change)="onCheckboxChange()" />
  <div></div>
</label>
